import React from "react";
import CardClass from "../../../CardClass";
import Table from "../../../Table";
import { withRouter } from 'react-router-dom';
import MUITextField from "@mui/material/TextField";
import MUIInputAdornment from "@mui/material/InputAdornment";
import MUISearchIcon from "@mui/icons-material/Search";
import api from "../../../../Seating/Security/api";
import Provider from "../../../../Utility/Crud/Provider";
import Throttle from "../../../../Utility/Throttle";

export default withRouter(class CardAdminProviderList extends CardClass {
    constructor(props) {
        super(props);
        this.state = {
            providers: [],
            currentSearchId: 0,
        };
        this.throttledHandleSearchChange = Throttle.throttle(
            this.handleSearchChange.bind(this),
            100,
            { "trailing": true }
        );
    }

    handleSearchChange(event) {
        // Makes sure only the most recent search result is rendered
        const searchId = this.state.currentSearchId + 1;
        this.setState({ currentSearchId: searchId });

        if (event.target.value) {
            api.send("POST", "/search/omniSearch/Provider", { omniSearchTerm: event.target.value, recordLimit: 20 })
                .then((data) => {
                    if (this.state.currentSearchId === searchId) {
                        this.setState({ providers: data.providers });
                    }
                })
                .catch((error) => {
                    console.error(error);
                    if (this.state.currentSearchId === searchId) {
                        this.setState({ providers: [] });
                    }
                });
        } else {
            this.setState({ providers: [] });
        }
    }

    renderContent() {
        return (
            <>
                <MUITextField
                    autoFocus={true}
                    placeholder="Type to search..."
                    hiddenLabel={true}
                    fullWidth={true}
                    variant="filled"
                    size="small"
                    sx={{
                        marginBottom: 2,
                        "& .MuiInputLabel-root": { display: "none", height: 0 }
                    }}
                    InputProps={{
                        startAdornment: (
                            <MUIInputAdornment position="start">
                                <MUISearchIcon />
                            </MUIInputAdornment>
                        ),
                        disableUnderline: true,
                        style: { borderRadius: 4 }
                    }}
                    onChange={this.throttledHandleSearchChange}
                />
                <Table
                    search={false}
                    columns={[
                        { key: "id", name: "ID", type: "string", width: 150 },
                        { key: "firstName", name: "First Name", type: "string" },
                        { key: "lastName", name: "Last Name", type: "string" },
                        { key: "npi", name: "NPI", type: "string" },
                    ]}
                    rows={this.state.providers}
                    onClick={(provider) => {
                        this.props.history.push({
                            pathname: "/admin/provider/" + provider.id
                        });
                    }}
                />
            </>
        );
    }
});
